export default __webpack_public_path__ + "00790b3758acdabdd2f14842e8207bd2.png";